import Index from "../views";
const Dashboard = () => import("../views/Dashboard.vue");
import Home from "../views/Home.vue";
import Payslip from "../views/Payslip.vue";
import GetStartedSuccess from "../views/GetStartedSuccess";
import GetStartedForm from "../views/GetStartedForm";
import ChangePassword from "../views/ChangePassword";
import PayrollRoutes from "../payroll/routes";
import PerformanceRoutes from "../performance/routes";
import AttendanceRoutes from "../attendance/routes";
const Support = () => import("../views/Support");
const Profile = () => import("../views/Profile");
const ActivityLogs = () => import("../views/ActivityLogs");

import HrmRoutes from "../hrm/routes";

export default [
  {
    path: "/ess",
    name: "ess",
    component: Index,
    redirect: "/ess/home",
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "change-password",
        name: "changePassword",
        component: ChangePassword,
      },
      {
        path: "support",
        name: "support",
        component: Support,
      },
      {
        path: "profile/:id",
        name: "profile",
        component: Profile,
      },
      {
        path: "activity-history",
        name: "activityHistory",
        component: ActivityLogs,
      },
      { path: "home", component: Home },
      { path: "dashboard", component: Dashboard },
      { path: "payslip", component: Payslip },
      {
        path: "hrm",
        redirect: "/ess/hrm/exemption",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: HrmRoutes,
      },
      {
        path: "attendance",
        redirect: "/ess/attendance/reports",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: AttendanceRoutes,
      },
      {
        path: "payroll",
        redirect: "/ess/payroll/loan",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: PayrollRoutes,
      },
      {
        path: "performance",
        redirect: "/ess/performance/dashboard",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: PerformanceRoutes,
      },
    ],
  },
  {
    path: "/get-started-success",
    component: GetStartedSuccess,
  },
  {
    path: "/get-started",
    component: GetStartedForm,
    meta: {
      requiresAuth: true,
    },
  },
];
